export default __webpack_public_path__ + "static/media/Payment-No-02.a31bbdf9.svg";